export default __webpack_public_path__ + "static/media/comment-mention.696a7e32.svg";